import React, { useEffect, useState } from "react";
import { TailSpin, ThreeDots } from "react-loader-spinner";
import BaseLayout from "../../layout/BaseLayout";
import Snackbar from "@mui/material/Snackbar";
import Pagination from "@mui/material/Pagination";
import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { NavLink, useNavigate } from "react-router-dom";
import { getListeAnneeAcademiquePagination } from "../../services/annee-academique/AnneeAcademiqueRequest";
import { getListeNiveauEtudePagination } from "../../services/niveau-etude/NiveauEtudeRequest";
import {
  enregistrementTarifService,
  getListeDesTarifsEnregistre,
  getListeServiceEtablissement,
  supprimerTarifService,
} from "../../services/tarifs/TarifsRequest";

const Tarifs = () => {
  const navigate = useNavigate();
  const [pageQuery, setPageQuery] = useState({
    page: 0,
    size: 7,
    nombrePage: 1,
    pagePagination: 1,
  });
  const [loadingData, setLoadingData] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [snackbarSuccessOpen, setSnackbarOpenSuccess] = useState(false);
  const [snackbarErrorOpen, setSnackbarOpenError] = useState(false);
  const [snackbarPosition, setSnackbarPosition] = useState({
    vertical: "bottom",
    horizontal: "center",
  });
  const [searchLoading, setSearchLoading] = useState(false);
  const [addLoading, setAddLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [desactiveLoading, setDesactiveLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [serviceListe, setServiceListe] = useState([]);
  const [niveauEtudeListe, setNiveauEtude] = useState([]);
  const [anneeScolaireListe, setAnneeScolaireListe] = useState([]);
  const [tarifListe, setTarifListe] = useState([]);
  const [tarifInfo, setTarifInfo] = useState(null);
  const [annee, setAnnee] = useState("");
  const [montant, setMontant] = useState("");
  const [niveau, setNiveau] = useState("");
  const [service, setService] = useState("");
  const [appRoute, setAppRoute] = useState("");

  const { vertical, horizontal } = snackbarPosition;

  const searchService = () => {
    setLoadingData(true);

    getListeDesTarifsEnregistre(
      pageQuery.page,
      pageQuery.size,
      searchTerm,
      annee,
      niveau,
      service
    )
      .then((res) => {
        setLoadingData(false);
        setTarifListe(res.data.donnee.tarifs);
        setPageQuery((prev) => ({
          ...prev,
          nombrePage: res.data.donnee.totalPages,
        }));
      })
      .catch((err) => {
        setLoadingData(false);
        console.log("api error", err);
      });
  };

  const modalDesactive = (service) => {
    setTarifInfo(service);
    document.getElementById("desactive-warning").click();
  };

  const clearFormulaireEnregistrementTarif = () => {
    setTarifInfo(null);
    setService("");
    setMontant("");
    setNiveau("");
    setAnnee("");
  };

  const modalCreateService = () => {
    setTarifInfo(null);
    setService("");
    setMontant("");
    setNiveau("");
    setAnnee("");
  };

  const modalEditTarif = (tarif) => {
    document.getElementById("ajout-tarif").click();
    setTarifInfo(tarif);
    setService(tarif.serviceMoMo.id);
    setMontant(tarif.montant);
    setNiveau(tarif.niveau.id);
    setAnnee(tarif.annee.id);
  };

  const getListeDesTarifs = () => {
    setLoadingData(true);
    getListeDesTarifsEnregistre(0, pageQuery.size)
      .then((res) => {
        setLoadingData(false);
        setTarifListe(res.data.donnee.tarifs);
        setPageQuery((prev) => ({
          ...prev,
          nombrePage: res.data.donnee.totalPages,
        }));
      })
      .catch((err) => {
        setLoadingData(false);
        console.log("api error", err);
      });
  };

  const getListeDesService = () => {
    setLoadingData(true);
    getListeServiceEtablissement()
      .then((res) => {
        setLoadingData(false);
        setServiceListe(res.data.donnee);
      })
      .catch((err) => {
        setLoadingData(false);
        console.log("api error", err);
      });
  };

  const getListeDesNiveauxEtude = () => {
    setLoadingData(true);
    getListeNiveauEtudePagination(0, 30000)
      .then((res) => {
        setLoadingData(false);
        setNiveauEtude(res.data.donnee.niveaux);
      })
      .catch((err) => {
        setLoadingData(false);
        console.log("api error", err);
      });
  };

  const getListeDesAnneeScolaire = () => {
    getListeAnneeAcademiquePagination(0, 30000)
      .then((res) => {
        setLoadingData(false);
        setAnneeScolaireListe(res.data.donnee.annees);
      })
      .catch((err) => {
        setLoadingData(false);
        console.log("api error", err);
      });
  };

  const ajoutNouveauTarif = () => {
    setAddLoading(true);
    const dataToSubmit = {
      id: tarifInfo ? tarifInfo.id : null,
      anneeId: annee,
      montant: montant,
      niveauId: niveau,
      serviceMoMoId: service,
    };

    enregistrementTarifService(dataToSubmit)
      .then((res) => {
        setSuccessMessage("Tarif enregistré avec succès");
        setSnackbarOpenSuccess(true);
        setAddLoading(false);
        document.getElementById("ajout-tarif").click();
        getListeDesTarifs();
        clearFormulaireEnregistrementTarif();
      })
      .catch((err) => {
        setAddLoading(false);
        if (err && err.response) {
          setErrorMessage(err.response.data.donnee);
          setSnackbarOpenError(true);
        } else {
          setErrorMessage("Erreur d'enregistrement, rééssayer!");
          setSnackbarOpenError(true);
        }
        console.log("api error", err);
      });
  };

  const supprimerTarif = () => {
    setDeleteLoading(true);

    const dataToDelete = {
      anneeId: tarifInfo.annee.id,
      montant: tarifInfo.montant,
      niveauId: tarifInfo.niveau.id,
      serviceMoMoId: tarifInfo.serviceMoMo.id,
    };

    supprimerTarifService(dataToDelete)
      .then((res) => {
        setSuccessMessage("Tarif supprimé avec succès");
        getListeDesTarifs();
        setSnackbarOpenSuccess(true);
        setDeleteLoading(false);
        document.getElementById("delete-warning").click();
      })
      .catch((err) => {
        setDeleteLoading(false);
        if (err.response.data) {
          setErrorMessage(err.response.data.donnee);
          setSnackbarOpenError(true);
        } else {
          setErrorMessage("Une erreur s'est produite, rééssayer!");
          setSnackbarOpenError(true);
        }
        console.log("api error", err);
      });
  };

  const changerEtatTarif = () => {};

  const handleCloseSnackbarSuccess = () => {
    setSnackbarOpenSuccess(false);
  };

  const handleCloseSnackbarError = () => {
    setSnackbarOpenError(false);
  };

  const handlePaginationChange = (event, value) => {
    setLoadingData(true);
    setPageQuery((prev) => ({
      ...prev,
      page: value,
      pagePagination: value,
    }));
    if (searchTerm.length !== 0) {
      // getListeUtilisateur(value - 1, pageQuery.size)
      //   .then((res) => {
      //     setUserListe(res.data.donnee.utilisateurs);
      //     setPageQuery((prev) => ({
      //       ...prev,
      //       nombrePage: res.data.donnee.totalPages,
      //     }));
      //     setLoadingData(false);
      //   })
      //   .catch((err) => {
      //     setLoadingData(false);
      //     console.log("api error", err);
      //   });
    } else {
      // getListeUtilisateur(value - 1, pageQuery.size, searchTerm)
      //   .then((res) => {
      //     setUserListe(res.data.donnee.utilisateurs);
      //     setPageQuery((prev) => ({
      //       ...prev,
      //       nombrePage: res.data.donnee.totalPages,
      //     }));
      //     setLoadingData(false);
      //   })
      //   .catch((err) => {
      //     setLoadingData(false);
      //     console.log("api error", err);
      //   });
    }
  };

  const TableElement = ({ tarif }) => {
    return (
      <tr>
        <td className="px-4">
          {tarif.serviceMoMo ? tarif.serviceMoMo.designation : ""}
        </td>
        <td className="px-4">{tarif.montant} FCFA</td>
        <td className="px-4">{tarif.niveau ? tarif.niveau.designation : ""}</td>
        <td className="px-4">{tarif.annee ? tarif.annee.designation : ""}</td>
        <td className="w-40 px-4">
          <div className="flex items-center gap-x-3">
            <label
              htmlFor="delete-warning"
              className="bg-gray-100 p-1 rounded-md text-gray-700 cursor-pointer"
              onClick={() => {
                document.getElementById("delete-warning").click();
                setTarifInfo(tarif);
              }}
            >
              <DeleteIcon />
            </label>
            <button
              className="bg-gray-100 p-1 rounded-md text-gray-700 cursor-pointer"
              onClick={() => modalEditTarif(tarif)}
            >
              <EditIcon />
            </button>
          </div>
        </td>
      </tr>
    );
  };

  useEffect(() => {
    setLoadingData(true);
    setAppRoute(localStorage.getItem("entiteRoute") ? localStorage.getItem("entiteRoute") : "")
    getListeDesTarifsEnregistre(pageQuery.page, pageQuery.size)
      .then((res) => {
        setLoadingData(false);
        setTarifListe(res.data.donnee.tarifs);
        setPageQuery((prev) => ({
          ...prev,
          nombrePage: res.data.donnee.totalPages,
        }));
      })
      .catch((err) => {
        setLoadingData(false);
        console.log("api error", err);
        if (err.response && err.response.status === 401) {
          localStorage.removeItem("momo4scoohclient")
          navigate("/login")
        }
      });

    getListeDesService();
    getListeDesNiveauxEtude();
    getListeDesAnneeScolaire();
  }, []);

  return (
    <BaseLayout>
      <div className="w-10/12 mx-auto pt-32">
        <h1 className="text-lg text-black font-bold">Paramètre</h1>
        <div className="flex items-center gap-x-2 mt-3">
          <NavLink to={`/${appRoute}/entite/tarifs`}>
            <h1 className="text-2xl text-momo-jaune font-bold cursor-pointer">
              Tarifs des services
            </h1>
          </NavLink>{" "}
          |{" "}
          <NavLink to={`/${appRoute}/entite/tarifs/modalite-paiement`}>
            <h1 className="text-2xl text-black font-bold cursor-pointer">
              Modalité de paiement
            </h1>
          </NavLink>
        </div>
        <div className="mt-10">
          <div className="mb-5 flex items-end justify-between">
            <div className="flex items-end gap-x-2">
              <div>
                <label className="label">
                  <span className="label-text">Service</span>
                </label>
                <select
                  value={service}
                  onChange={(e) => setService(e.target.value)}
                  className="select select-bordered w-full font-normal"
                >
                  <option value="" disabled selected>
                    Choisir un service
                  </option>
                  <option value="">Tous</option>
                  {serviceListe.map((item) => (
                    <option value={item.id} key={item.id}>
                      {item.designation}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="label">
                  <span className="label-text">Niveau d'étude</span>
                </label>
                <select
                  value={niveau}
                  onChange={(e) => setNiveau(e.target.value)}
                  className="select select-bordered w-full font-normal"
                >
                  <option value="" disabled selected>
                    Choisir un niveau
                  </option>
                  <option value="">Tous</option>
                  {niveauEtudeListe.map((item) => (
                    <option value={item.id} key={item.id}>
                      {item.designation}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="label">
                  <span className="label-text">Année scolaire</span>
                </label>
                <select
                  value={annee}
                  onChange={(e) => setAnnee(e.target.value)}
                  className="select select-bordered w-full font-normal"
                >
                  <option value="" disabled selected>
                    Choisir une année
                  </option>
                  <option value="">Tous</option>
                  {anneeScolaireListe.map((item) => (
                    <option value={item.id} key={item.id}>
                      {item.designation}
                    </option>
                  ))}
                </select>
              </div>
              <button
                disabled={searchLoading}
                className="w-14 h-12 bg-stone-900 text-white rounded-md flex items-center justify-center"
                onClick={searchService}
              >
                {!searchLoading ? (
                  <SearchIcon />
                ) : (
                  <TailSpin
                    height="25"
                    width="25"
                    color="#fff"
                    ariaLabel="tail-spin-loading"
                    radius="1"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={searchLoading}
                  />
                )}
              </button>
            </div>
            <label
              htmlFor="ajout-tarif"
              className="bg-momo-blue text-white px-3 py-2 rounded-lg font-medium cursor-pointer"
              onClick={modalCreateService}
            >
              Ajouter un tarif
            </label>
          </div>

          <div className="overflow-x-auto">
            <table className="table table-compact w-full mb-2">
              <thead>
                <tr>
                  <th className="capitalize py-4 px-4">Nom du service</th>
                  <th className="capitalize py-4 px-4">Montant tarif</th>
                  <th className="capitalize py-4 px-4">Niveau d'étude</th>
                  <th className="capitalize py-4 px-4">Année scolaire</th>
                  <th className="capitalize py-4 px-4">Actions</th>
                </tr>
              </thead>
              <tbody>
                {!loadingData && tarifListe.length > 0 ? (
                  tarifListe.map((item) => (
                    <TableElement key={item.id} tarif={item} />
                  ))
                ) : !loadingData && tarifListe.length === 0 ? (
                  <tr>
                    <td colSpan="5">
                      <div className="w-full h-32 bg-white rounded-br-lg rounded-bl-lg flex gap-x-2 text-red-500 items-center justify-center">
                        <ErrorOutlineIcon />
                        <p className="font-medium text-red-500">
                          Aucun élément trouvé
                        </p>
                      </div>
                    </td>
                  </tr>
                ) : loadingData && tarifListe.length === 0 ? (
                  <tr>
                    <td colSpan="5">
                      <div className="w-full h-32 bg-white rounded-br-lg rounded-bl-lg flex gap-x-2 text-red-500 items-center justify-center">
                        <TailSpin
                          height="50"
                          width="50"
                          color="#000"
                          ariaLabel="tail-spin-loading"
                          radius="1"
                          wrapperStyle={{}}
                          wrapperClass=""
                          visible={loadingData}
                        />
                      </div>
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td colSpan="5">
                      <div className="w-full h-32 bg-white rounded-br-lg rounded-bl-lg flex gap-x-2 text-red-500 items-center justify-center">
                        <TailSpin
                          height="50"
                          width="50"
                          color="#000"
                          ariaLabel="tail-spin-loading"
                          radius="1"
                          wrapperStyle={{}}
                          wrapperClass=""
                          visible={loadingData}
                        />
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="flex justify-end">
              <Pagination
                count={pageQuery.nombrePage}
                page={pageQuery.pagePagination}
                variant="outlined"
                shape="rounded"
                onChange={handlePaginationChange}
              />
            </div>
          </div>
        </div>
      </div>

      {/* MODAL AJOUT SERVICE */}
      <input type="checkbox" id="ajout-tarif" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box">
          <h3 className="font-bold text-lg">
            {tarifInfo === null ? "Ajouter un tarif" : "Modifier ce tarif"}
          </h3>
          <div className="py-4">
            <div>
              <label className="label">
                <span className="label-text">Service</span>
              </label>
              <select
                value={service}
                onChange={(e) => setService(e.target.value)}
                className="select select-bordered w-full font-normal"
              >
                <option value="" disabled selected>
                  Choisir un service
                </option>
                {serviceListe.map((item) => (
                  <option value={item.id} key={item.id}>
                    {item.designation}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="label">
                <span className="label-text">Niveau d'étude</span>
              </label>
              <select
                value={niveau}
                onChange={(e) => setNiveau(e.target.value)}
                className="select select-bordered w-full font-normal"
              >
                <option value="" disabled selected>
                  Choisir un niveau
                </option>
                {niveauEtudeListe.map((item) => (
                  <option value={item.id} key={item.id}>
                    {item.designation}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="label">
                <span className="label-text">Année scolaire</span>
              </label>
              <select
                value={annee}
                onChange={(e) => setAnnee(e.target.value)}
                className="select select-bordered w-full font-normal"
              >
                <option value="" disabled selected>
                  Choisir une année scolaire
                </option>
                {anneeScolaireListe.map((item) => (
                  <option value={item.id} key={item.id}>
                    {item.designation}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="label">
                <span className="label-text">Tarif du service (FCFA)</span>
              </label>
              <input
                disabled={addLoading}
                type="text"
                value={montant}
                onChange={(e) => setMontant(e.target.value)}
                placeholder="3214"
                className="input input-bordered w-full"
              />
            </div>
          </div>
          <div className="modal-action">
            {!addLoading ? (
              <label
                htmlFor="ajout-tarif"
                className="bg-black text-white font-bold px-4 py-2 rounded-md cursor-pointer"
              >
                Annuler
              </label>
            ) : (
              <label
                htmlFor="ajout-tarif"
                className="bg-black text-white font-bold px-4 py-2 rounded-md pointer-events-none"
              >
                Annuler
              </label>
            )}
            <button
              disabled={addLoading}
              className="bg-momo-jaune text-black font-bold px-4 py-2 rounded-md"
              onClick={ajoutNouveauTarif}
            >
              {!addLoading ? (
                <span>{!tarifInfo ? "Enregistrer" : "Modifier"}</span>
              ) : (
                <ThreeDots
                  height="20"
                  width="40"
                  radius="9"
                  color="#000"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={addLoading}
                />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* SUPPRIMER SERVICE */}
      <input type="checkbox" id="delete-warning" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box">
          <h3 className="font-bold text-2xl text-center text-red-500">
            Attention !
          </h3>
          <p className="text-lg text-center py-4">
            Cette action est irréversible
          </p>
          <div className="modal-action flex justify-center gap-x-5">
            {!deleteLoading ? (
              <label
                id="delete-warning-btn"
                htmlFor="delete-warning"
                className="bg-gray-300 text-black font-bold px-4 py-2 rounded-md cursor-pointer"
              >
                Annuler
              </label>
            ) : (
              <label
                htmlFor="delete-warning"
                className="bg-gray-300 text-black font-bold px-4 py-2 rounded-md pointer-events-none"
              >
                Annuler
              </label>
            )}
            <button
              disabled={deleteLoading}
              className="bg-red-500 text-white font-bold px-4 py-2 rounded-md flex items-center justify-center"
              onClick={supprimerTarif}
            >
              {!deleteLoading ? (
                <span>Supprimer</span>
              ) : (
                <ThreeDots
                  height="20"
                  width="40"
                  radius="9"
                  color="#fff"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={deleteLoading}
                />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* DESACTIVER UTILISATEUR */}
      <input type="checkbox" id="desactive-warning" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box">
          <h3
            className={
              tarifInfo && tarifInfo.enabled
                ? "font-bold text-2xl text-center text-red-500"
                : "font-bold text-2xl text-center text-green-500"
            }
          >
            {tarifInfo && tarifInfo.enabled
              ? "Désactiver ce tarif"
              : "Activer ce tarif"}
          </h3>
          <div className="modal-action flex justify-center gap-x-5">
            {!desactiveLoading ? (
              <label
                id="desactive-warning-btn"
                htmlFor="desactive-warning"
                className="bg-gray-300 text-black font-bold px-4 py-2 rounded-md cursor-pointer"
              >
                Annuler
              </label>
            ) : (
              <label
                htmlFor="desactive-warning"
                className="bg-gray-300 text-black font-bold px-4 py-2 rounded-md pointer-events-none"
              >
                Annuler
              </label>
            )}
            <button
              disabled={desactiveLoading}
              className={
                tarifInfo && tarifInfo.enabled
                  ? "bg-red-500 text-white font-bold px-4 py-2 rounded-md flex items-center justify-center"
                  : "bg-green-500 text-white font-bold px-4 py-2 rounded-md flex items-center justify-center"
              }
              onClick={changerEtatTarif}
            >
              {!desactiveLoading ? (
                <>
                  {tarifInfo && tarifInfo.enabled ? (
                    <span>Désactiver</span>
                  ) : (
                    <span>Activer</span>
                  )}
                </>
              ) : (
                <ThreeDots
                  height="20"
                  width="40"
                  radius="9"
                  color="#fff"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={desactiveLoading}
                />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* SNACKBAR SUCCESS */}
      {successMessage ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={snackbarSuccessOpen}
          autoHideDuration={2000}
          onClose={handleCloseSnackbarSuccess}
          key={vertical + horizontal}
        >
          <div className="bg-green-500 text-white px-10 py-3 rounded-lg">
            {successMessage}
          </div>
        </Snackbar>
      ) : null}

      {/* SNACKBAR ERROR */}
      {errorMessage ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={snackbarErrorOpen}
          autoHideDuration={2000}
          onClose={handleCloseSnackbarError}
          key={vertical + horizontal}
        >
          <div className="bg-red-500 text-white px-10 py-3 rounded-lg">
            {errorMessage}
          </div>
        </Snackbar>
      ) : null}
    </BaseLayout>
  );
};

export default Tarifs;
